import { OnInit, EventEmitter } from '@angular/core';
import { StorageService } from '../../_services/storage.service';
import { NgxGalleryComponent } from 'ngx-gallery';
import { SrcPipe } from '../../_pipe/src.pipe';
var GalleriaFotograficaComponent = /** @class */ (function () {
    function GalleriaFotograficaComponent(storage) {
        this.storage = storage;
        this.galleryImages = [];
        this.urlFotoEsterno = false;
        this.openFotoIndexChange = new EventEmitter();
        this.galleryOptions = [
            {
                width: '0px',
                height: '0px',
                image: false,
                thumbnails: false,
                thumbnailsColumns: 4,
                previewSwipe: true,
                previewKeyboardNavigation: true,
                previewDescription: true,
                previewInfinityMove: true,
                previewCloseOnEsc: true,
                imageDescription: true,
                previewCloseOnClick: true,
            },
        ];
    }
    Object.defineProperty(GalleriaFotograficaComponent.prototype, "openFotoIndex", {
        set: function (index) {
            if (index !== null && index !== undefined) {
                this.gallery.openPreview(index);
                this.openFotoIndexChange.emit(null);
            }
        },
        enumerable: true,
        configurable: true
    });
    GalleriaFotograficaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.galleryImages = [];
        var srcPipe = new SrcPipe();
        this.foto.forEach(function (foto) {
            var url = _this.urlFotoEsterno ? foto.url : srcPipe.transform(foto.path, 'landscape_4_3_desktop');
            var urlMobile = _this.urlFotoEsterno ? foto.url : srcPipe.transform(foto.path, 'landscape_4_3_mobile');
            _this.galleryImages.push({
                small: urlMobile,
                medium: urlMobile,
                big: url,
                alt: foto.alt,
                title: foto.title,
                note: foto.note,
                description: foto.alt
            });
        });
        if ((this.galleryImages.length - 4) > 0) {
            this.galleryPlus = true;
        }
    };
    return GalleriaFotograficaComponent;
}());
export { GalleriaFotograficaComponent };
